const ID_KEY = 'tid';
const EXP_KEY = 'texp';
const EXPIRY_DURATION = 3600 * 24;

const getExpiry = () => {
  const raw = localStorage.getItem(EXP_KEY);

  if (raw && !Number.isNaN(Number(raw))) {
    return Number(raw);
  }

  return Number(new Date());
};

const generateTransactionId = () => {
  return Math.random().toString(36).substr(2, 9);
};

const getTransactionId = expiry => {
  const transactionId = localStorage.getItem(ID_KEY);
  const now = Number(new Date());

  if (!transactionId || now >= expiry) {
    return generateTransactionId();
  }

  return transactionId;
};

const expiry = getExpiry();
const transactionId = getTransactionId(expiry);
localStorage.setItem(ID_KEY, transactionId);
localStorage.setItem(EXP_KEY, String(expiry + EXPIRY_DURATION));
export default transactionId;